import axios from '@fs/zion-axios'
import { i18n } from '@fs/zion-locale'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'

export const getRelatives = () => {
  return axios.get(`${serviceBaseUrl}/relatives?language=${i18n.language}`)
}

export const dummy = () => {}
